export default "__VITE_ASSET__8ed91f6b__"